import OvrFileService from './service';

export * from './reqres';

export default OvrFileService;
